export default __webpack_public_path__ + "static/media/story-3l.b26decf6.png";